<template>
  <div class="BcConfirmBodyDeleteFile">
    <h3 class="text-lg leading-6 font-medium text-gray-800">
      {{ confirm.header }}
    </h3>
    <div class="mt-5">
      <p 
        v-if="confirm.text && confirm.text != ''"
        class="text-sm text-gray-800"
      >
        {{ confirm.text }}
      </p>
    </div>
    <template v-for="file in confirm.files" :key="file.id">
      <span class="block mt-5 mb-3" v-if="confirm.files.length > 1">
        {{ file.name }}
      </span>
      <template v-if="file.documents.length">
        <span class="block mt-5 mb-3">
          {{ $t('Used in documents:') }}
        </span>
        <ul>
          <li 
            v-for="(breadcrumbs, i) in file.documents"
            :key="i"
            class="text-sm mb-2 flex flex-row"
          >
            <aw-icon
              icon="document"
              class="w-5 h-5 mr-3"
            />
            <a 
              :href="getBreadCrumbsUrl(breadcrumbs)"
              target="_blank"
              class="text-bc-blue"
            >
              {{ getBreadCrumbsText(breadcrumbs) }}
            </a>
          </li>
        </ul>
      </template>
      <template v-if="file.documentRevisions.length">
        <span class="block mt-5 mb-3">
          {{ $t('Used in documents revisions:') }}
        </span>
        <ul>
            <li 
              v-for="(documentRevision, i) in file.documentRevisions"
              :key="i"
              class="text-sm mb-2 flex flex-row"
            >
              <aw-icon
                icon="document"
                class="w-5 h-5 mr-3"
              />
              <a 
                :href="getBreadCrumbsUrl(documentRevision.breadcrumbs)"
                target="_blank"
                class="text-bc-blue"
              >
                {{ getBreadCrumbsText(documentRevision.breadcrumbs) }} (rev. {{ documentRevision.revision }})
              </a>
            </li>
        </ul>
      </template>
      <template v-if="file.design.documents.length">
        <span class="block mt-5 mb-3">
          {{ $t('Used as document image in:') }}
        </span>
        <ul>
          <li 
            v-for="(breadcrumbs, i) in file.design.documents"
            :key="i"
            class="text-sm mb-2 flex flex-row"
          >
            <aw-icon
              icon="document"
              class="w-5 h-5 mr-3"
            />
            <a 
              :href="getBreadCrumbsUrl(breadcrumbs)"
              target="_blank"
              class="text-bc-blue"
            >
              {{ getBreadCrumbsText(breadcrumbs) }}
            </a>
          </li>
        </ul>
      </template>
      <template v-if="file.design.folders.length">
        <span class="block mt-5 mb-3">
          {{ $t('Used as folder image in:') }}
        </span>
        <ul>
          <li 
            v-for="(breadcrumbs, i) in file.design.folders"
            :key="i"
            class="text-sm mb-2 flex flex-row"
          >
            <aw-icon
              icon="folder"
              class="w-5 h-5 mr-3"
            />
            <a 
              :href="getBreadCrumbsUrl(breadcrumbs)"
              target="_blank"
              class="text-bc-blue"
            >
              {{ getBreadCrumbsText(breadcrumbs) }}
            </a>
          </li>
        </ul>
      </template>
      <template v-if="file.design.settings.length">
        <span class="block mt-5 mb-3">
          {{ $t('Used in design settings:') }}
        </span>
        <ul>
          <li 
            v-for="(breadcrumbs, i) in file.design.settings"
            :key="i"
            class="text-sm mb-2 flex flex-row"
          >
            <aw-icon
              icon="cog"
              class="w-5 h-5 mr-3"
            />
            <a 
              :href="getBreadCrumbsUrl(breadcrumbs)"
              target="_blank"
              class="text-bc-blue"
            >
              {{ getBreadCrumbsText(breadcrumbs) }}
            </a>
          </li>
        </ul>
      </template>
    </template>
    
  </div>
</template>

<script>
export default {
  props: {
    confirm: {
      type: Object,
      default: null
    },
  },
  methods: {
    getBreadCrumbsText(breadcrumbs) {
      return breadcrumbs.map(crumb => {
        return crumb.name
      }).join(' / ')
    },
    getBreadCrumbsUrl(breadcrumbs) {
      return breadcrumbs[breadcrumbs.length-1].url
    },
  }
}
</script>

<style scoped>
.BcConfirmBodyDeleteFile ul li svg {
  min-width: 1.25rem;
}
</style>